import React, { useMemo } from "react";
import { DataTable } from "./DataTable";
import { format } from "date-fns";
import InvoiceMenuSelect from "./InvoiceMenuSelect";

const defaultSortBy = [
  {
    id: "invDate",
    desc: true,
  },
];

const InvoiceHistoryTable = ({
  invoices,
  onPrintInvoiceClick,
  isError,
  isLoading,
}) => {
  const tableColumns = React.useMemo(
    () => [
      {
        Header: "Invoice",
        accessor: "invNo",
        disableSortBy: true,
      },
      {
        Header: "Invoice Date",
        accessor: "invDate",
        Cell: ({ value }) => format(new Date(value), "MM/dd/yyyy"),
        disableFilters: true,
        sortType: "datetime",
      },

      {
        Header: "Cutoff Date",
        accessor: "invTo",
        Cell: ({ value }) => format(new Date(value), "MM/dd/yyyy"),
        disableFilters: true,
        sortType: "datetime",
      },
      {
        Header: "Total Amount",
        accessor: "total",
        Cell: ({ value }) =>
          value.toLocaleString("en-US", { style: "currency", currency: "USD" }),
        disableFilters: true,
        // sortType: "number",
      },
      {
        Header: "Paid",
        accessor: "paid",
        Cell: ({ value }) =>
          value.toLocaleString("en-US", { style: "currency", currency: "USD" }),
        disableFilters: true,
        // sortType: "number",
      },
      {
        Header: "Balance",
        accessor: "balance",
        Cell: ({ value }) =>
          value.toLocaleString("en-US", { style: "currency", currency: "USD" }),
        disableFilters: true,
        // sortType: "number",
      },
      {
        Header: "Options",
        accessor: "invoiceMenu",
        Cell: ({ value }) => (
          <InvoiceMenuSelect
            invoiceId={value}
            onPrintInvoiceClick={(e) => {
              e.preventDefault();
              onPrintInvoiceClick(value.invoiceNumber);
            }}
          />
        ),
        disableFilters: true,
        disableSortBy: true,
        width: 75, //same issue as the other tables where if we make this too small it'll look weird. Order history table seems to be fine
      },
    ],
    [onPrintInvoiceClick]
  );

  const tableData = useMemo(
    () =>
      invoices.map((val) => ({
        invNo: val.invNo,
        invDate: new Date(val.invDate),
        invTo: new Date(val.invTo),
        total: val.total,
        paid: val.paid,
        balance: val.balance,
        invoiceMenu: {
          clientId: val.clientId,
          invoiceNumber: val.invNo,
          invoiceType: val.invt,
        },
      })),
    [invoices]
  );

  return (
    <DataTable
      columns={tableColumns}
      data={tableData}
      isLoading={isLoading}
      isError={isError}
      initialState={{
        sortBy: defaultSortBy,
      }}
      slotProps={{
        topToolbar: { disabled: true },
      }}
    />
  );
};

export default InvoiceHistoryTable;
